import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-sensor-manufacturing-ci-cd-casestudy',
  templateUrl: './sensor-manufacturing-ci-cd-casestudy.component.html',
  styleUrls: ['./sensor-manufacturing-ci-cd-casestudy.component.css']
})
export class SensorManufacturingCiCdCasestudyComponent {
  isBrowser:boolean=false;
  baseUrl=Constants.baseUrl;
  isOpen: boolean[] = [];
  isAdditionalOpen: boolean[] = [];
   constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit() { 
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/sensor_manufacturing_-ci_cd_casestudy/"
  },
  "headline": "Supercharge with Cloud & Automation",
  "description": "Learn how Maganti IT partnered with a manufacturing client to build a resilient and future-ready, strategy-driven cloud infrastructure.",
  "image": "https://mitresource.com/assets/images/managedservicesensor/ManagedServicesSensors_mobile-Banner.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2023-11-15"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();

    if(this.isBrowser){ 
      this.isOpen = new Array(this.accordionItems.length).fill(false);
    this.isAdditionalOpen = new Array(this.additionalaccordionItems.length).fill(false);
   
    AOS.init({disable: 'mobile'});
    document.addEventListener("DOMContentLoaded", () => {
      const accordionHeads = document.querySelectorAll(".accordion_head");
 
      accordionHeads.forEach((accordionHead) => {
          accordionHead.addEventListener("click", function(this: HTMLElement) {
              const accordionBody = this.nextElementSibling as HTMLElement;
              const plusMinus = this.querySelector(".plusminus") as HTMLElement;
 
              const allAccordionBodies = document.querySelectorAll(".accordion_body");
              allAccordionBodies.forEach((body) => {
                  if (body !== accordionBody && (body as HTMLElement).style.display === 'block') {
                      (body as HTMLElement).style.display = 'none';
                      const plusMinusText = (body as HTMLElement).previousElementSibling?.querySelector(".plusminus") as HTMLElement;
                      if (plusMinusText) {
                          plusMinusText.textContent = '+';
                      }
                  }
              });
 
              if (window.getComputedStyle(accordionBody).display === 'block') {
                  accordionBody.style.display = 'none';
                  plusMinus.textContent = '+';
              } else {
                  accordionBody.style.display = 'block';
                  plusMinus.textContent = '-';
              }
          });
      });
  });
}
  }



  scrollToSection(sectionId: string) {
    if(this.isBrowser){
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }}
  }
 
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Improving Flawless Release Cycle: A customized CI/CD framework for a Sensor Technology Giant!');

    this.metaService.addTags([
      { name: 'description', content: 'Our client, a leading sensor manufacturing company, has been facing a number of industry-wide challenges that have been hindering their progress!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Improving Flawless Release Cycle: A customized CI/CD framework for a Sensor Technology Giant' },
      { property: 'og:url', content: 'https://mitresource.com/sensor_manufacturing_-ci_cd_casestudy/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/sensor_manufacturing/Looking_ahead.png' },
      { property: 'og:description', content: 'Our client, a leading sensor manufacturing company, has been facing a number of industry-wide challenges that have been hindering their progress.' },
    ]);
  }
  accordionItems = [
    { title: 'Global Presence with Minimal Downtime', content: 'Our client now boasts a strong global website presence achieved with minimal downtime, ensuring uninterrupted availability worldwide.  ' },
    { title: 'Efficient Deployment through DevOps', content: ' Utilizing DevOps practices has streamlined application deployment, emphasizing rigorous pre-production validation for high-quality releases, accelerating deployment and strengthening application reliability.' },
    { title: 'Error Reduction and Swift Issue Resolution', content: ' CI/CD pipelines minimize human error, leading to a 50% decrease in change failure rates. Early bug identification through automated tests enables real-time issue resolution, reducing downtime and enhancing software system reliability.'}
  ]

  additionalaccordionItems = [
    { title: 'CI/CD Cultivates Innovation', content: ' CI/CD pipelines drive continuous improvement and innovation, boasting a 50% increase in experimental capabilities. Qualitative gains include a faster feedback  loop, scalability, boosted developer morale, heightened customer satisfaction, continuous monitoring, and integrated compliance and security. Swift rollbacks and hotfixes add agility to issue resolution.' },
    { title: 'CI/CD Cuts Time-to-Market', content: '  Implementing a CI/CD pipeline has reduced time-to-market by an average of 33%, facilitating swift and frequent delivery of features and bug fixes for a competitive advantage. ' },
    { title: 'Collaboration Boost with CI/CD', content: 'CI/CD pipelines enhance collaboration, promoting parallel work, breaking down silos, and fostering faster development cycles, ultimately improving software quality.' },
   
  ];
  toggleAccordion(index: number): void {
    this.isOpen = this.isOpen.map((_, i) => i === index ? !this.isOpen[i] : false);
  }

  toggleAdditionalAccordion(index: number): void {
    this.isAdditionalOpen = this.isAdditionalOpen.map((_, j) => j === index ? !this.isAdditionalOpen[j] : false);
  }
}
